<template>
  <div class="create">
    <p class="create__title h2">Создание площадки</p>

<!--    <p>{{ $store.getters['createField/requestBody'] }}</p>-->

    <AppMenu
      :modelValue="activeMenuItem"
      :items="menuItems"
      @update:modelValue="onMenu"
    />

    <KeepAlive>
      <component
        :is="componentName"
        class="create__content"
        @next="onNext"
      />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppInformation from './components/AppInformation'
import AppMap from './components/AppMap'
import AppSchedule from './components/AppSchedule'
import AppPhotoUpload from './components/AppPhotoUpload'

export default {
  name: 'create-field',
  components: {
    AppInformation,
    AppMap,
    AppSchedule,
    AppPhotoUpload,
    AppMenu
  },
  data () {
    return {
      menuItems: [
        { value: 'information', label: 'Информация', component: 'AppInformation' },
        { value: 'schedule', label: 'График работы', component: 'AppSchedule' },
        { value: 'map', label: 'Местоположение', component: 'AppMap' },
        { value: 'images', label: 'Фотографии', component: 'AppPhotoUpload' }
      ],
      activeMenuItem: 'information',
      maxActiveIndex: 0
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  },
  methods: {
    async sendImage (id, base64image) {
      this.$api.field.photoUpload(id, base64image)
    },
    async onCreateField () {
      try {
        const body = this.$store.getters['createField/requestBody']
        const { data } = await this.$api.field.create(body)
        const id = data?.id

        const base64Images = await this.$store.getters['createField/imagesStep/base64Images']

        for (const item of base64Images) {
          await this.sendImage(id, item)
        }

        this.$router.push('/fields/' + id)
      } catch (e) {
        console.log(e)
      }
    },
    onNext () {
      const nextIndex = this.menuItems.findIndex(item => item.value === this.activeMenuItem) + 1

      /* Если это последний шаг, то отправляем данные на сервер */
      if (nextIndex === this.menuItems.length) {
        this.onCreateField()
        return
      }

      /* перехожу на следующий таб */
      this.activeMenuItem = this.menuItems[nextIndex].value

      /* записываю максимальный пройденный шаг */
      if (this.maxActiveIndex < nextIndex) {
        this.maxActiveIndex = nextIndex
      }
    },
    onMenu (tabName) {
      const curIndex = this.menuItems.findIndex(item => item.value === tabName)

      /* если максимальный пройденный шаг позволяет, то открыть в таб */
      if (curIndex <= this.maxActiveIndex) {
        this.activeMenuItem = tabName
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.create {
  &__title {
    margin-bottom: 14px;
  }

  &__content {
    margin-top: 30px;
  }
}
</style>
